import { InjectionToken } from "@angular/core";


export enum LegalHubTabs {
    SETTINGS = 'SETTINGS',
    GUIDELINES = "GUIDELINES"
}

export const LHSubmitFormButtonTranslationKey = new InjectionToken<string>('LHSubmitFormButtonTranslationKey');